import { useTranslation } from "react-i18next";
import { CheckboxRadio, InputField, TypeSelect } from "ui-components";
import { setSessionStorageItem } from "../../../../../utils/SessionStorageMethod/setSessionStorageItem";
interface BudgetProps {
  isTaxChecked: boolean;
  setIsTaxChecked: (checked: boolean) => void;
  setMinBudget: (min: any) => void;
  setMaxBudget: (max: any) => void;
  minBudget: any;
  maxBudget: any;
  handleCurrencyChange: (e: any) => void;
  currencyList: any;
  selectedCurrency: any;
}
const Budget = ({
  isTaxChecked,
  setIsTaxChecked,
  setMinBudget,
  setMaxBudget,
  minBudget,
  maxBudget,
  handleCurrencyChange,
  currencyList,
  selectedCurrency,
}: BudgetProps) => {
  const { t } = useTranslation();
  return (
    <div className="budgetSection">
      <span className="comSubLabel">{t("RESUME.BUDGET")}</span>
      <div className="taxInclusiveCheckbox">
        <CheckboxRadio
          label={t("RESUME.INCLUSIVE_TAXES")}
          type="checkbox"
          checked={isTaxChecked}
          onChange={() => {
            setIsTaxChecked(!isTaxChecked);
            setSessionStorageItem("isTaxChecked", !isTaxChecked);
          }}
        />
      </div>
      <div className="budgetRow mt-3">
        <div className="budgetLabelRow">
          <div className="currencySec">
            <span>{t("RESUME.CURRENCY")}</span>
            <div className="currencyDropDown">
              <TypeSelect
                options={currencyList}
                placeholder="$"
                onChange={handleCurrencyChange}
                value={selectedCurrency}
              />
            </div>
          </div>
          <div className="currencySec">
            <span>{t("RESUME.MIN")}</span>
            <InputField
              onChange={(e: any) => setMinBudget(e)}
              value={minBudget}
              placeholder="0"
            />
          </div>
          <div className="currencySec">
            <span>{t("RESUME.MAX")}</span>
            <InputField
              onChange={(e: any) => setMaxBudget(e)}
              value={maxBudget}
              placeholder="0"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Budget;
